import Vue from "vue";
import analytics from "../../utils/analytics";
import analyticsPlugin from "../../utils/eventAnalytics/plugin";

const state = {
	models: sessionStorage.getItem("weeekly-jackpot-models")
		? JSON.parse(sessionStorage.getItem("weekly-jackpot-models"))
		: {},
};

const getDefaultModel = () => {
	return Object.assign(
		{},
		{
			betslip: [],
			stake: null,
			selectedOdds: [],
		}
	);
};

const persistModel = (key, item) => {
	let models = sessionStorage.getItem("weekly-jackpot-models")
		? JSON.parse(sessionStorage.getItem("weekly-jackpot-models"))
		: {};
	models[key] = item;
	sessionStorage.setItem("weekly-jackpot-models", JSON.stringify(models));
};

const getters = {
	model: (state) => (id) => {
		return state.models[id] ? state.models[id] : getDefaultModel();
	},
};

const mutations = {
	addToBetslip(state, bet) {
		let model = state.models[bet.id] ? state.models[bet.id] : getDefaultModel();
		model.betslip.push(Object.assign({}, bet));
		Vue.set(state.models, bet.id, model);
		persistModel(bet.id, model);
		analyticsPlugin.betSlip.add({
			appName: "MOBILE_WEB",
			betType: "jackpots",
			display: bet.display || null,
			matchId: bet.matchId || null,
			profileId: window.localStorage.getItem("user")
				? JSON.parse(window.localStorage.getItem("user")).id
				: "",
			betPick: bet.bet_pick || null,
			homeTeam: bet.home_team || null,
			awayTeam: bet.away_team || null,
			oddValue: bet.odd_value || null,
			market: bet.market || null,
			startTime: bet.startTime || null,
		});
	},
	removeFromBetslip(state, bet) {
		let model = state.models[bet.id] ? state.models[bet.id] : getDefaultModel();
		model.betslip = model.betslip.filter(
			(b) => b.match.parent_match_id != bet.match.parent_match_id
		);
		Vue.set(state.models, bet.id, model);
		persistModel(bet.id, model);
	},
	updateStake(state, payload) {
		let model = state.models.hasOwnProperty(payload.id)
			? Object.assign({}, state.models[payload.id])
			: getDefaultModel();
		model.stake = Object.assign({}, payload.stake);
		Vue.set(state.models, payload.id, model);
		persistModel(payload.id, model);
	},
	addToSelectedOdds(state, payload) {
		let model = state.models[payload.id]
			? state.models[payload.id]
			: getDefaultModel();
		let odd = {
			parent_match_id: payload.match.parent_match_id,
			odds: [payload.odd],
		};
		// model.selectedOdds = []
		model.selectedOdds.push(odd);
		Vue.set(state.models, payload.id, model);
		persistModel(payload.id, model);
	},
	updateSelectedOdds(state, payload) {
		let model = state.models[payload.id]
			? state.models[payload.id]
			: getDefaultModel();
		let odd = {
			parent_match_id: payload.match.parent_match_id,
			odds: [payload.odd],
		};
		let oddIndex = model.selectedOdds.findIndex(
			(odd) => odd.parent_match_id == payload.match.parent_match_id
		);

		if (oddIndex > -1) {
			model.selectedOdds[oddIndex].odds.push(Object.assign({}, payload.odd));
		} else {
			model.selectedOdds.push(odd);
		}
		Vue.set(state.models, payload.id, model);
		persistModel(payload.id, model);
	},
	replaceSelectedOdds(state, payload) {
		let model = state.models[payload.id]
			? state.models[payload.id]
			: getDefaultModel();
		let oddIndex = model.selectedOdds.findIndex(
			(odd) => odd.parent_match_id == payload.match.parent_match_id
		);
		model.selectedOdds[oddIndex].odds = [];
		model.selectedOdds[oddIndex].odds.push(Object.assign({}, payload.odd));
		Vue.set(state.models, payload.id, model);
		persistModel(payload.id, model);
	},
	removeSelectedOdds(state, payload) {
		let model = state.models[payload.id]
			? state.models[payload.id]
			: getDefaultModel();
		let oddIndex = model.selectedOdds.findIndex(
			(odd) => odd.parent_match_id == payload.match.parent_match_id
		);
		// model.selectedOdds.filter(odds => odds.parent_match_id == payload.match.parent_match_id && odds.odds.findIndex(odd => odd.odd_def != payload.odd.odd_def && odd.outcome_id != payload.odd.outcome_id))
		model.selectedOdds[oddIndex].odds = model.selectedOdds[
			oddIndex
		].odds.filter(
			(odd) =>
				odd.odd_def != payload.odd.odd_def &&
				odd.outcome_id != payload.odd.outcome_id
		);
		Vue.set(state.models, payload.id, model);
		persistModel(payload.id, model);
	},
	updateBetslipOdd(state, payload) {
		let model = state.models.hasOwnProperty(payload.id)
			? Object.assign({}, state.models[payload.id])
			: getDefaultModel();
		let betIndex = model.betslip.findIndex(
			(bet) => bet.match.parent_match_id == payload.match.parent_match_id
		);
		model.betslip[betIndex].odd = payload.odd;
		Vue.set(state.models, payload.id, model);
		persistModel(payload.id, model);
	},
	clear(state, meta) {
		let model = state.models[meta.id]
			? state.models[meta.id]
			: getDefaultModel();
		model.betslip = [];
		model.selectedOdds = [];
		Vue.set(state.models, meta.id, model);
		persistModel(meta.id, model);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
